module.exports = __webpack_public_path__ + "static/media/5_of_diamonds.87a4ed7f.png";